import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { PageContent } from 'components/PageStyles';

export const ProjectRoute = styled(Link)`
  text-decoration: none;
`;

export const PlaceholderPageContent = styled(PageContent)`
  margin-top: 70px;
`;

export const FavoritesContainer = styled.section`
  margin-bottom: 24px;
  padding-bottom: 8px;
`;

export const FavoritesEmptyHint = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: ${(props) => props.theme['color.blackLighter']};
  opacity: 0.85;
`;

export const MainProjectsCollapsibleSection = styled.section`
  margin-bottom: 24px;
`;

export const MainProjectsToggleHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  margin: 0 0 12px 0;
  padding: 8px 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: ${(props) => props.theme['color.blackLighter']};

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme['color.purpleLight']};
    outline-offset: 2px;
  }
`;

export const MainProjectsToggleTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
`;
